var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { PageHeaderAppbuilder, PageHeaderControlsAppbuilder, PageHeaderTitleAppbuilderWithInfo, PageWrapperAppbuilder, } from '../../app-builder/app-builder-styles';
import BreadcrumbsAppBuilder from '../../app-builder/BreadcrumbsAppBuilder';
import { AddToDashButton, HelpButton, PageContent, } from '../../components/Page';
import Search from '../../components/Search/Search.element';
import { PermissionsWrapper } from '../../components/PermissionsWrapper';
import { ContentPadding, LoadingSpinner, Spacer } from '../../components/base';
import { LoaderPosition } from '../../components/Page/styles';
import { Button } from '@appspotr/ui-kit';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faGrid2Plus } from '@fortawesome/pro-regular-svg-icons/faGrid2Plus';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Table from '../../components/TableWithFixedColumns';
import { useSelector, useDispatch } from 'react-redux';
import { makeSelectPaginationIndex } from '../Root/selectors';
import { loadApps, setPagination } from '../Root/actions';
import { InfoTooltip } from '../../app-builder/utils/InfoTooltip';
import { NoAppsDescription, NoAppsIcon, NoAppsTitle, NoAppsWRapper, TableWrapper, } from './styles';
import { COLORS } from '../../themes';
import Modal from '../../components/CommonModal';
import { deletePushMultiApp, loadPushMultiApps, } from '../../store/pushMultiApps/actions';
import { selectSenderApps, selectSenderAppsLoading, } from '../../store/pushMultiApps/selectors';
import CreateModal from './CreateModal';
import toast from '../../components/Toast';
import { AppDetails } from '../../components/CommonBuilderProperties/styles';
import DefaultAppIcon from '../../images/default-app-icon.png';
var columns = [
    {
        accessor: 'name_with_icon',
        header: 'App Details',
        widthPercentage: '100%',
        sortColumn: 'name',
        searchColumn: 'name',
    },
];
var PushNotificationsSenderApps = function (_a) {
    var _b;
    var match = _a.match;
    var _c = match.params, appId = _c.appId, organizationId = _c.organizationId;
    var dispatch = useDispatch();
    var _d = useState(''), searchValue = _d[0], setSearchValue = _d[1];
    var _e = useState(false), isVisibleConfirmation = _e[0], setIsVisibleConfirmation = _e[1];
    var _f = useState(''), idToDelete = _f[0], setIdToDelete = _f[1];
    var _g = useState(false), isVisibleAddModal = _g[0], setIsVisibleAddModal = _g[1];
    //=useEffect============================================================================
    useEffect(function () {
        dispatch(loadPushMultiApps(appId));
    }, [dispatch, appId]);
    useEffect(function () {
        dispatch(loadApps());
    }, [dispatch]);
    //=!useEffect============================================================================
    //=props============================================================================
    var senderApps = useSelector(selectSenderApps);
    var senderAppsLoading = useSelector(selectSenderAppsLoading);
    var paginationIndex = useSelector(makeSelectPaginationIndex("/organizations/".concat(organizationId, "apps/").concat(appId, "/push/senderapps"))());
    //=dispatch============================================================================
    var goToPage = function (pageNumber) {
        return dispatch(setPagination("/organizations/".concat(organizationId, "apps/").concat(appId, "/push/senderapps"), pageNumber));
    };
    //=!props============================================================================
    var onDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var deleted;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(deletePushMultiApp(appId, idToDelete))];
                case 1:
                    deleted = _a.sent();
                    if (deleted) {
                        dispatch(loadPushMultiApps(appId));
                        toast.success('Sender app deleted');
                    }
                    else {
                        toast.error('Something went wrong while deleting the app');
                    }
                    setIsVisibleConfirmation(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var crumbs = [{ to: '', text: "Push Multi-Apps" }];
    var senderAppsData = senderApps === null || senderApps === void 0 ? void 0 : senderApps.map(function (app) {
        return {
            id: app.parent_app,
            name: app.parent_app_name,
            name_with_icon: (_jsxs(AppDetails, { children: [_jsx("img", { src: app.parent_app_icon || DefaultAppIcon, alt: "Logo", width: "40px", height: "40px" }), app.parent_app_name] })),
        };
    });
    var appToDelete = ((_b = senderApps === null || senderApps === void 0 ? void 0 : senderApps.find(function (a) { return a.parent_app === idToDelete; })) === null || _b === void 0 ? void 0 : _b.parent_app_name) || '';
    return (_jsxs(PageWrapperAppbuilder, { children: [_jsx(CreateModal, { appId: appId, isVisible: isVisibleAddModal, setIsVisible: setIsVisibleAddModal }), _jsx(Modal, { isVisible: isVisibleConfirmation, setIsVisible: setIsVisibleConfirmation, title: "Remove App", titleBlockBorderBottom: true, modalBody: _jsxs(_Fragment, { children: ["Are you sure you want to remove '", appToDelete, "' from the multi-apps?. This action cannot be undone ", _jsx("br", {}), "( Your app may be used to configure multi-apps in the '", appToDelete, "'. )"] }), actionButtonContent: "Remove App", actionButtonOnClick: onDelete, actionButtonType: "danger", deleteModal: true, cancelText: "Dismiss" }), _jsxs(PageHeaderAppbuilder, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: "Push Notifications" }), _jsx("meta", { name: "description", content: "Description of PushNotifications" })] }), _jsxs(PageHeaderTitleAppbuilderWithInfo, { children: [_jsx(BreadcrumbsAppBuilder, { crumbs: crumbs }), _jsx(InfoTooltip, { info: _jsx(_Fragment, { children: "Content needed" }) })] }), _jsxs(PageHeaderControlsAppbuilder, { children: [_jsx(AddToDashButton, {}), _jsx(HelpButton, { currentLocation: location.pathname }), _jsx(Search, { onChangeFilter: function (value) { return setSearchValue(value); }, type: "TABLE", dark: true, placeholder: "Search apps" }), _jsx(PermissionsWrapper, __assign({ target: "org:".concat(organizationId, ":orgadmin"), action: "create" }, { children: _jsxs(Button, __assign({ type: "primary", onClick: function () {
                                        setIsVisibleAddModal(true);
                                    } }, { children: [_jsx(FontAwesomeIcon, { icon: faPlus }), _jsx(Spacer, { type: "narrow" }), "New App"] })) }))] })] }), _jsx(PageContent, { children: _jsx(ContentPadding, { children: !senderAppsLoading ? (_jsx(TableWrapper, { children: Boolean(senderApps.length) ? (_jsx(Table, { columns: columns, data: senderAppsData, searchValue: searchValue, setIsVisibleDeleteConfirmation: setIsVisibleConfirmation, setIdToDelete: setIdToDelete, actionColumnWidth: 86, paginationIndex: paginationIndex, setPagination: goToPage, showSelectRow: false })) : (_jsxs(NoAppsWRapper, { children: [_jsx(NoAppsIcon, { children: _jsx(FontAwesomeIcon, { icon: faGrid2Plus, size: "3x", color: COLORS.mutedGray }) }), _jsx(NoAppsTitle, { children: "No Push Multi-Apps yet" }), _jsxs(NoAppsDescription, { children: ["Push Multi Apps: This powerful feature lets you effortlessly send push notifications to all your connected apps from a single interface. Once you link a new app, it becomes instantly possible to broadcast messages from the newly added app to others in the network.", _jsx("br", {}), _jsx("br", {}), " For instance, if your main app is 'App A' and you add 'App B', you can then send notifications to 'App B' directly from 'App A'. It\u2019s a streamlined way to manage your communication across multiple platforms, saving you time and enhancing your reach"] }), _jsx(PermissionsWrapper, __assign({ target: "org:".concat(organizationId, ":orgadmin"), action: "create" }, { children: _jsx(Button, __assign({ type: "secondary", onClick: function () {
                                            setIsVisibleAddModal(true);
                                        } }, { children: "Add New App" })) }))] })) })) : (_jsx(LoaderPosition, { children: _jsx(LoadingSpinner, {}) })) }) })] }));
};
export default PushNotificationsSenderApps;
